var VolcEnvEnum = /* @__PURE__ */ ((VolcEnvEnum2) => {
  VolcEnvEnum2["online"] = "online";
  VolcEnvEnum2["stable"] = "stable";
  VolcEnvEnum2["byteplus"] = "byteplus";
  VolcEnvEnum2["coze"] = "coze";
  VolcEnvEnum2["coze_code"] = "coze_code";
  return VolcEnvEnum2;
})(VolcEnvEnum || {});
export {
  VolcEnvEnum
};
